import { ILlmDashboardPayload, LlmConversationNode } from '@adaptiva/ai/common';
import { IUserDashboard, ObjectManagerService } from '@adaptiva/data-service';
import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';

export function getDashboardArtifactName(_artifact: LlmConversationNode<ILlmDashboardPayload>): Observable<string> {
	const _objectManager: ObjectManagerService = inject(ObjectManagerService);
	const _payload: ILlmDashboardPayload = _artifact.payload;

	return _objectManager.streamObject<IUserDashboard>({
		fetch: () => _objectManager.getObjectById(
			_payload.javaClassName,
			_payload.objectId,
		)
	}).pipe(
		map(d => d.name)
	);
}
